import API from '../../../services/apiService.js'

var api= new API();


export default {

  // Загрузить данные по пользователям Web
  async loadWebUsers ({ commit }) {
    var data=null;
    try{
      data = await api.Get("UserService/WebUser");
      commit('loadWebUsers', data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

// Загрузить данные по пользователям Mobile
  async loadMobileUsers ({ commit }) {
    var data=null;
    try{
      data = await api.Get("UserService/Client/GetAllByAccessLevel");
      commit('loadMobileUsers', data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //добавить web пользователя
  async addWebUser({commit}, data) {
    var newData = null;
    var newId = null;
    try {
      newId = await api.Post("UserService/WebUser", data);
      if (newId != null) {
        var getparams = '?Id=' + newId.id;
        newData = await api.Get("UserService/WebUser/GetById" + getparams)
      }
      if (newData != null && newData != "")
        commit('addWeb', newData);
    } catch (e) {
      console.log(e);
        throw new Error(e);
    }
  },

  //редактировать web пользователя
  async editWebUser({commit}, data) {
    try {
      await api.Put("UserService/WebUser", data);

    } catch (e) {
      console.log(e);
        throw new Error(e);
    }
  },

  //удалить web пользователя
  async deleteWebUser({commit}, Id) {
    try {
      var getparams = '?WebUserId=' + Id;
      await api.Delete("UserService/WebUser", getparams);

    } catch (e) {
      console.log(e);
        throw new Error(e);
    }
  },

  //добавить mobile пользователя
  async addMobileUser({commit}, data) {

    var newId = null;
    try {
      newId = await api.Post("UserService/Client", data);
    } catch (e) {
      console.log(e);
        throw new Error(e);
    }
  },

  //редактировать web пользователя
  async editMobileUser({commit}, data) {
    try {
      await api.Put("UserService/Client", data);

    } catch (e) {
      console.log(e);
        throw new Error(e);
    }
  },

  //удалить web пользователя
  async deleteMobileUser({commit}, Id) {
    try {
      var getparams = '?ClientId=' + Id;
      await api.Delete("UserService/Client", getparams);
    } catch (e) {
      console.log(e);
    }
  },

    // получить историю активаций пользователя
    async getClientActivations ({ commit }, Id) {
        var data=null;
        try{
            var getparams = '?ClientId=' + Id;
            data = await api.Get("BonusService/BonusActivation/GetCompletedClientBonuses"+getparams);
            commit('setClientActivates', data);
        }catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    // получить бонусы пользователя
    async getClientBonuses ({ commit }, Id) {
        var data=null;
        try{
            var getparams = '?ClientId=' + Id;
            data = await api.Get("BonusService/ClientBonus"+getparams);
            commit('setClientBonuses', data);
        }catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

}
